import React from "react";
import Layout from "./Layout";
import TorneosSection from "../sections/TorneosSection";

const Torneos = () => {
  return (
    <>
      <Layout>
        <TorneosSection />
      </Layout>
    </>
  );
};

export default Torneos;
